<template>
  <div class="bg-loginimg">
    <div class="container" id="login-form">
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <div class="panel panel-default login-ragis-formstylechen-aftersell">
            <form
              name="form"
              @submit.prevent="handleLogin"
              class="form-horizontal"
              id="validate-form"
            >
              <div class="panel-body asloginvew">
                <div class="loginheader">
                  <a href="#" class="login-logo"
                    ><img src="assets/img/logo-dark.png"
                  /></a>
                  <h2>Login</h2>
                </div>

                <div class="form-group mb-md">
                  <div class="col-xs-12">
                    <div class="input-group">
                      <label for="username">Email</label>
                      <input
                        v-model="user.username"
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        name="username"
                      />
                      <div
                        v-if="errors.has('username')"
                        class="alert alert-danger"
                        role="alert"
                      >
                        Username is required!
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-md">
                  <div class="col-xs-12">
                    <div class="input-group">
                      <label for="password">Password</label>
                      <input
                        v-model="user.password"
                        v-validate="'required'"
                        type="password"
                        class="form-control"
                        name="password"
                      />
                      <div
                        v-if="errors.has('password')"
                        class="alert alert-danger"
                        role="alert"
                      >
                        Password is required!
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="form-group mb-n">
                    <div class="col-xs-6">
                      <label
                        ><input type="checkbox" /> &nbsp; Remember Me</label
                      >
                    </div>

                    <div class="col-xs-6">
                      <a href="#" class="pull-left">Forgot password?</a>
                    </div>
                  </div> -->

                <div class="col-xs-12">
                  <div class="loginrgitr pull-left">
                    <h4>Register</h4>
                    <router-link to="/register"
                      >Register Organisation</router-link>
                  </div>
                  <div class="loginrgitr pull-right">
                    <br>
                    <br>
                    <router-link to="/passwordReset/takeEmail"
                      >Forget Password</router-link>
                  </div>
                </div>
              </div>
              <div class="panel-footer">
                <div class="clearfix">
                  <button
                    type="submit"
                    class="btn btn-primary submitbtn btn-raised pull-right"
                    :disabled="loading"
                  >
                    <span> Login </span>
                  </button>
                </div>
                <div class="form-group">
                  <div v-if="message" class="alert alert-danger" role="alert">
                    {{ message }}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="copyright">
        <p class="center">
          Copyright 2021, GladMinds Technologies Pvt Ltd. All Right Reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../models/user';

export default {
  name: 'Login',
  data() {
    return {
      user: new User('', ''),
      loading: false,
      message: '',
    };
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'simple-layout');
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      //  this.$router.push('/profile');
    }
  },
  methods: {
    submitClick() {
      this.$refs.form.submit();
    },
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch('auth/login', this.user).then(
            () => {
              if (!this.$store.state.auth.otp_verify) {
                this.$router.push('/otp');
              }
            },
            (error) => {
              this.loading = false;
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      });
    },
  },
};
</script>
<style>

.focused-form {
	background: #00b9d4;
}
</style>

